import { API_URL } from "../config/connect";

/** translations: { kk: { title, text }, en: { title, text } } — пользователь видит текст на языке устройства */
const postNotifications = async (title, text, fileBase64, notificationType, translations = undefined) => {
    const endpoint = `${API_URL}/api/v1/admin/news`;
    const googleIdToken = localStorage.getItem("google_id_token");

    try {
        const response = await fetch(endpoint, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${googleIdToken}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                title,
                text,
                file: fileBase64,
                notification_type: notificationType,
                ...(translations ? { translations } : {}),
            }),
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            const detail = errorData?.detail;
            const message =
                errorData?.error?.validation_errors?.[0]?.message ||
                (typeof detail === "string" && detail) ||
                detail?.[0]?.msg ||
                `Ошибка запроса (${response.status})`;
            const error = new Error(response.status === 403 ? "Отправлять уведомления может только администратор." : message);
            error.status = response.status;
            throw error;
        }

        return await response.json();
    } catch (error) {
        console.error("Ошибка при отправке уведомления:", error);
        throw error;
    }
};

export default postNotifications;